import script from "./PartnerOnboardingFormTermsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PartnerOnboardingFormTermsPage.vue?vue&type=script&lang=ts&setup=true"

import "./PartnerOnboardingFormTermsPage.vue?vue&type=style&index=0&id=0cfc7633&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cfc7633"]])

export default __exports__